var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Landing.Messages.Submit, Vendd.Landing, function (envelope) {
            var options = {
		        url: 'CommonService.svc/LandingSubmit',
		        data: envelope.message.data,
		        onSuccess: onSuccess,
		        onFailure: onFailure
		    };

            function onSuccess(response) {
                Vendd.MessageBus.publishAsync(Vendd.Landing, new Vendd.Landing.Messages.SubmitSuccess(response));
			};

			function onFailure(response) {
			    Vendd.MessageBus.publishAsync(Vendd.Landing, new Vendd.Landing.Messages.SubmitFailure(response));
			};

			Vendd.Service.call(options);
    	});

    return Vendd;

})(Vendd || {});